import React from 'react';

import ProductListScreen from '../common/ProductListScreen';
import ProductList from './ProductList';

const Products = () => <ProductListScreen List={ProductList} />;

export default Products;
